﻿  (function () {
    // --- Discount helpers ---
    function getDiscountConfig() {
      var el = document.getElementById('discount-config');
      if (!el) return null;
      try {
        return JSON.parse(el.textContent);
      } catch (e) {
        return null;
      }
    }

    function getDiscountCookie() {
      var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
      var code = m ? decodeURIComponent(m[1]) : null;
      if (code) {
        try {
          sessionStorage.setItem('ive_discount_code', code);
          sessionStorage.setItem('ive_discount_ts', Date.now());
        } catch (e) {}
        return code;
      }
      try {
        var saved = sessionStorage.getItem('ive_discount_code');
        var ts = sessionStorage.getItem('ive_discount_ts');
        if (saved && ts && (Date.now() - parseInt(ts, 10) < 7 * 24 * 60 * 60 * 1000)) {
          return saved;
        }
      } catch (e) {}
      return null;
    }

    function isDiscountActive(config) {
      if (!config) return false;
      if (config.auto) return true;
      var code = getDiscountCookie();
      return code && config.codes.some(function(c) { return c === btoa(code); });
    }

    function formatMoneyCents(cents) {
      var formatEl = document.querySelector('.total-price-container');
      var format = formatEl ? formatEl.dataset.moneyFormat : '{{amount}}';
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        var html = Shopify.formatMoney(cents, format);
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        return tmp.textContent || tmp.innerText || html;
      }
      var amount = (cents / 100).toFixed(2);
      var parts = amount.split('.');
      if (format.indexOf('{{amount_with_comma_separator}}') !== -1) {
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        amount = parts[0] + ',' + parts[1];
        return format.replace('{{amount_with_comma_separator}}', amount);
      }
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      amount = parts[0] + '.' + parts[1];
      return format.replace('{{amount}}', amount);
    }

    function calcDiscountedPrice(originalCents, config) {
      switch (config.type) {
        case '百分比':
          if (config.value >= 100) return 0;
          return Math.round(originalCents * (1 - config.value / 100));
        case '固定金额':
          return Math.max(0, originalCents - Math.round(config.value * 100));
        case '免费':
          return 0;
        default:
          return originalCents;
      }
    }

    function applyDiscountToItem(itemEl, config) {
      var checkbox = itemEl.querySelector('.js-rec-check');
      var select = itemEl.querySelector('.js-recommend-variant-select');
      var originalPriceRaw;

      if (select) {
        var opt = select.options[select.selectedIndex];
        originalPriceRaw = parseInt(opt.dataset.originalPriceRaw, 10) || parseInt(opt.dataset.priceRaw, 10) || 0;
      } else {
        originalPriceRaw = parseInt(checkbox.dataset.originalPriceRaw, 10) || parseInt(checkbox.dataset.priceRaw, 10) || 0;
      }

      var discounted = calcDiscountedPrice(originalPriceRaw, config);

      // update data-price-raw so updateTotalPrice uses discounted value
      checkbox.setAttribute('data-price-raw', discounted);
      if (select) {
        select.options[select.selectedIndex].setAttribute('data-price-raw', discounted);
      }

      var priceEl = itemEl.querySelector('.recommend-product-price');
      if (!priceEl) return;
      var ins = priceEl.querySelector('.js-price__current');
      var del = priceEl.querySelector('.js-price__compare');

      if (ins) {
        var isFree = config.type === '免费' || (config.type === '百分比' && config.value >= 100) || discounted === 0;
        ins.textContent = isFree ? (config.freeLabel || 'Free') : formatMoneyCents(discounted);
      }

      var displayOriginal = formatMoneyCents(originalPriceRaw);
      if (del) {
        del.textContent = displayOriginal;
        del.style.fontSize = 'var(--12-14)';
      } else {
        del = document.createElement('del');
        del.className = 'js-price__compare';
        del.style.fontSize = 'var(--12-14)';
        del.textContent = displayOriginal;
        priceEl.appendChild(del);
      }

      var recommendDiv = itemEl.querySelector('.js-recommend-checkbox');
      if (recommendDiv) {
        var savings = originalPriceRaw - discounted;
        var tag = recommendDiv.querySelector('.dealtag');
        if (savings > 0) {
          if (!tag) {
            tag = document.createElement('div');
            tag.className = 'dealtag absolute';
            tag.style.cssText = 'right:-2px;top:-2px;font-size:14px;background:var(--brandmaincolor);color:#fff;padding:3px 6px;';
            recommendDiv.appendChild(tag);
          }
          tag.textContent = config.bundleLabel + ' -' + formatMoneyCents(savings);
          tag.style.display = '';
          recommendDiv.style.padding = '16px 0';
        }
      }
    }

    function applyDiscountToAllItems() {
      var config = getDiscountConfig();
      if (!isDiscountActive(config)) return;

      var container = document.querySelector('.ivelok-template');
      if (!container) return;
      container.querySelectorAll('.js-product-item').forEach(function(item) {
        if (item.querySelector('.js-rec-check[data-original-price-raw]')) {
          applyDiscountToItem(item, config);
        }
      });

      if (config.type === '免费') {
        container.querySelectorAll('.js-rec-check[data-original-price-raw]').forEach(function(box) {
          box.checked = true;
        });
        if (container._updateTotalPrice) container._updateTotalPrice();
      }

      container.querySelectorAll('.js-drawer-label[data-discount-text]').forEach(function(label) {
        label.textContent = label.dataset.discountText;
      });
    }
    // --- End discount helpers ---

    function initGallery() {
      if (typeof Swiper === 'undefined') {
        setTimeout(initGallery, 50);
        return;
      }
      document.querySelectorAll('.js-ivelok-grally').forEach(function (el) {
        if (el.swiper) return;
        var slides = el.querySelectorAll('.swiper-slide');
        if (slides.length === 0) return;

        var thumbsEl = el.closest('.leftmedia').querySelector('.js-ivelok-thumbs');
        var thumbsSwiper = null;

        if (thumbsEl) {
          thumbsSwiper = new Swiper(thumbsEl, {
            slidesPerView: 'auto',
            spaceBetween: 8,
            freeMode: true,
            watchSlidesProgress: true,
          });
        }

        var config = {
          nested: true,
        };

        var paginationEl = el.querySelector('.js-number');
        if (paginationEl) {
          config.pagination = {
            el: paginationEl,
            type: 'fraction',
          };
        }

        var nextEl = el.querySelector('.swiper-button-next');
        var prevEl = el.querySelector('.swiper-button-prev');
        if (nextEl && prevEl) {
          config.navigation = {
            nextEl: nextEl,
            prevEl: prevEl,
          };
        }

        if (thumbsSwiper) {
          config.thumbs = {
            swiper: thumbsSwiper,
          };
        }

        new Swiper(el, config);
      });
    }
    function initRecommendGalleries() {
      if (typeof Swiper === 'undefined') {
        setTimeout(initRecommendGalleries, 50);
        return;
      }
      document.querySelectorAll('.js-recommend-gallery').forEach(function (el) {
        if (el.swiper) return;
        var slides = el.querySelectorAll('.swiper-slide');
        if (slides.length === 0) return;

        var thumbsEl = el.parentElement.querySelector('.js-recommend-thumbs');
        var thumbsSwiper = null;
        if (thumbsEl) {
          thumbsSwiper = new Swiper(thumbsEl, {
            slidesPerView: 'auto',
            spaceBetween: 8,
            freeMode: true,
            watchSlidesProgress: true,
          });
        }

        var config = { nested: true };

        var nextEl = el.querySelector('.recommend-gallery-next');
        var prevEl = el.querySelector('.recommend-gallery-prev');
        if (nextEl && prevEl) {
          config.navigation = { nextEl: nextEl, prevEl: prevEl };
        }

        if (thumbsSwiper) {
          config.thumbs = { swiper: thumbsSwiper };
        }

        new Swiper(el, config);
      });
    }

    function initVideoGallery() {
      if (typeof Swiper === 'undefined') {
        setTimeout(initVideoGallery, 50);
        return;
      }
      document.querySelectorAll('.js-ivelok-video-gallery').forEach(function (el) {
        if (el.swiper) return;
        var slides = el.querySelectorAll('.swiper-slide');
        if (slides.length === 0) return;

        var thumbsEl = el.parentElement.querySelector('.js-ivelok-video-thumbs');
        var thumbsSwiper = null;

        if (thumbsEl) {
          thumbsSwiper = new Swiper(thumbsEl, {
            slidesPerView: 'auto',
            spaceBetween: 8,
            freeMode: true,
            watchSlidesProgress: true,
          });
        }

        var config = {
          nested: true,
          navigation: {
            nextEl: el.querySelector('.swiper-button-next'),
            prevEl: el.querySelector('.swiper-button-prev'),
          },
          on: {
            slideChange: function () {
              var prevSlide = this.slides[this.previousIndex];
              if (prevSlide) {
                prevSlide.querySelectorAll('video').forEach(function (v) {
                  v.pause();
                });
              }
            },
          },
        };

        if (thumbsSwiper) {
          config.thumbs = {
            swiper: thumbsSwiper,
          };
        }

        new Swiper(el, config);
      });
    }

    function initMediaTabs() {
      if (typeof Swiper === 'undefined') {
        setTimeout(initMediaTabs, 50);
        return;
      }
      var tabsContainer = document.querySelector('.js-ivelok-media-tabs');
      if (!tabsContainer) return;

      var tabs = tabsContainer.querySelectorAll('.js-media-tab');
      if (tabs.length === 0) return;

      var swiperInstance = new Swiper(tabsContainer, {
        allowTouchMove: false,
        autoHeight: true,
        on: {
          slideChange: function () {
            var prevSlide = this.slides[this.previousIndex];
            if (prevSlide) {
              prevSlide.querySelectorAll('video').forEach(function (v) {
                v.pause();
              });
            }
            var activeIndex = this.activeIndex;
            tabs.forEach(function (t) {
              t.classList.remove('active');
            });
            var activeTab = tabsContainer.querySelector('.js-media-tab[data-slide="' + activeIndex + '"]');
            if (activeTab) activeTab.classList.add('active');
          },
        },
      });

      tabsContainer.swiper = swiperInstance;

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var slideIndex = parseInt(this.dataset.slide, 10);
          swiperInstance.slideTo(slideIndex);
          tabs.forEach(function (t) {
            t.classList.remove('active');
          });
          this.classList.add('active');
        });
      });
    }

    function initLightbox() {
      if (typeof Swiper === 'undefined') {
        setTimeout(initLightbox, 50);
        return;
      }
      var lightboxEl = document.querySelector('.js-ivelok-lightbox');
      var swiperEl = document.querySelector('.js-ivelok-lightbox-swiper');
      if (!lightboxEl || !swiperEl) return;

      var swiperInstance = null;

      function open(index) {
        lightboxEl.style.display = 'flex';
        document.body.style.overflow = 'hidden';
        if (!swiperInstance) {
          swiperInstance = new Swiper(swiperEl, {
            loop: false,
            navigation: {
              nextEl: swiperEl.querySelector('.swiper-button-next'),
              prevEl: swiperEl.querySelector('.swiper-button-prev'),
            },
          });
        }
        swiperInstance.slideTo(index, 0);
      }

      function close() {
        lightboxEl.style.display = 'none';
        document.body.style.overflow = '';
      }

      document.querySelectorAll('.js-ivelok-grally .swiper-slide').forEach(function (slide, index) {
        slide.addEventListener('click', function () {
          open(index);
        });
      });

      lightboxEl.querySelectorAll('.js-ivelok-lightbox-close').forEach(function (el) {
        el.addEventListener('click', close);
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') close();
      });
    }

    function initVariantSelection() {
      var container = document.querySelector('.ivelok-template');
      var variantInfoEl = container ? container.querySelector('script[data-variant-info]') : null;
      if (!variantInfoEl) return;
      var variantInfo;
      try {
        variantInfo = JSON.parse(variantInfoEl.textContent);
      } catch (e) {
        return;
      }

      var optionGroups = container.querySelectorAll('.js-product-option .product-option');

      function getSelectedOptions() {
        var selected = [];
        optionGroups.forEach(function (group) {
          var idx = parseInt(group.dataset.optionIndex, 10);
          var activeBtn = group.querySelector('.js-option-button.active');
          selected[idx] = activeBtn ? activeBtn.dataset.value : '';
        });
        return selected;
      }

      function findVariantByOptions(options) {
        for (var id in variantInfo) {
          if (!variantInfo.hasOwnProperty(id)) continue;
          var v = variantInfo[id];
          if (!v.options) continue;
          var match = true;
          for (var i = 0; i < options.length; i++) {
            if (v.options[i] !== options[i]) {
              match = false;
              break;
            }
          }
          if (match) return { id: id, data: v };
        }
        return null;
      }

      function updateInput() {
        var options = getSelectedOptions();
        var variant = findVariantByOptions(options);
        if (variant) {
          container.dataset.selectedVariant = variant.id;
          container.dataset.selectedSku = variant.data.sku || '';
        }
      }

      function updateGallery() {
        var options = getSelectedOptions();
        var variant = findVariantByOptions(options);
        var imageId = variant && variant.data.image_id ? variant.data.image_id : null;

        if (!imageId && variant) {
          var colorIdx = parseInt(container.dataset.colorOptionIndex || '0', 10);
          var colorValue = options[colorIdx];
          for (var id in variantInfo) {
            if (!variantInfo.hasOwnProperty(id)) continue;
            var v = variantInfo[id];
            if (v.options && v.options[colorIdx] === colorValue && v.image_id) {
              imageId = v.image_id;
              break;
            }
          }
        }

        if (!imageId) return;

        var mediaTabs = container.querySelector('.js-ivelok-media-tabs');
        if (mediaTabs && mediaTabs.swiper) {
          mediaTabs.swiper.slideTo(0);
        }

        var gallery = container.querySelector('.js-ivelok-grally');
        if (!gallery || !gallery.swiper) return;
        var slides = gallery.querySelectorAll('.swiper-slide');
        var targetIndex = -1;
        slides.forEach(function (slide, index) {
          if (slide.dataset.imageId == imageId) {
            targetIndex = index;
          }
        });
        if (targetIndex >= 0) {
          gallery.swiper.slideTo(targetIndex);
        }
      }

      function stripHtml(str) {
        if (!str) return '';
        var tmp = document.createElement('div');
        tmp.innerHTML = str;
        return tmp.textContent || tmp.innerText || '';
      }

      function updatePrice() {
        var options = getSelectedOptions();
        var variant = findVariantByOptions(options);
        if (!variant) return;
        var priceEl = container.querySelector('.js-price');
        var compareEl = container.querySelector('.js-compare-price');
        if (priceEl) {
          priceEl.textContent = stripHtml(variant.data.price_formatted);
        }
        if (compareEl) {
          if (variant.data.compare_at_price > 0) {
            compareEl.textContent = stripHtml(variant.data.compare_at_price_formatted);
            compareEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
          }
        }
      }

      function updateCurrentValues() {
        optionGroups.forEach(function (group) {
          var activeBtn = group.querySelector('.js-option-button.active');
          var currentEl = group.querySelector('.js-option-current');
          if (currentEl && activeBtn) {
            currentEl.textContent = activeBtn.dataset.value;
          }
        });
      }

      function updateColorSwatches() {
        var colorIdx = parseInt(container.dataset.colorOptionIndex || '0', 10);
        var currentOptions = getSelectedOptions();
        var colorGroup = container.querySelector('.product-option[data-option-index="' + colorIdx + '"]');
        if (!colorGroup) return;
        var buttons = colorGroup.querySelectorAll('.js-option-button');
        buttons.forEach(function (btn) {
          var colorValue = btn.dataset.value;
          var tempOptions = currentOptions.slice();
          tempOptions[colorIdx] = colorValue;
          var matched = findVariantByOptions(tempOptions);
          if (!matched) {
            for (var id in variantInfo) {
              if (!variantInfo.hasOwnProperty(id)) continue;
              var v = variantInfo[id];
              if (v.options && v.options[colorIdx] === colorValue && v.swatch_image) {
                matched = { id: id, data: v };
                break;
              }
            }
          }
          var img = btn.querySelector('.js-swatch-img');
          if (img && matched && matched.data.swatch_image) {
            img.src = matched.data.swatch_image;
          }
        });
      }

      function updateQuantity() {
        var options = getSelectedOptions();
        var variant = findVariantByOptions(options);
        if (!variant) return;
        var qtyInput = container.querySelector('.js-quantity-input');
        if (!qtyInput) return;
        var maxQty = variant.data.inventory_quantity;
        if (maxQty <= 0) {
          maxQty = 9999;
        }
        qtyInput.setAttribute('max', maxQty);
        var currentVal = parseInt(qtyInput.value, 10) || 1;
        if (currentVal > maxQty) {
          qtyInput.value = maxQty;
        }
      }

      function updateAddToCartButton() {
        var options = getSelectedOptions();
        var variant = findVariantByOptions(options);
        var addBtn = container.querySelector('.js-product-add-cart');
        var addBtnText = container.querySelector('.js-product-add-to-cart-button-text');
        var buyBtn = container.querySelector('.js-buy-now-btn');
        var notifyBtn = container.querySelector('.js-notify-me-trigger');
        if (!addBtn || !addBtnText) return;
        var translationsEl = document.querySelector('script[data-ive-translations]');
        var translations = translationsEl ? JSON.parse(translationsEl.textContent) : {};
        if (variant && variant.data.available) {
          addBtn.disabled = false;
          addBtn.classList.remove('is-disabled');
          addBtnText.textContent = translations.add_to_cart || '';
          if (buyBtn) { buyBtn.disabled = false; buyBtn.style.display = ''; }
          if (notifyBtn) notifyBtn.style.display = 'none';
        } else {
          addBtn.disabled = true;
          addBtn.classList.add('is-disabled');
          addBtnText.textContent = translations.sold_out || '';
          if (buyBtn) buyBtn.style.display = 'none';
          if (notifyBtn) notifyBtn.style.display = '';
        }
        var skuInput = container.querySelector('.js-notify-me-sku');
        if (skuInput) {
          skuInput.value = container.dataset.selectedSku || '';
        }
      }

      function updateStockStates() {
        var currentSelected = getSelectedOptions();
        optionGroups.forEach(function (group) {
          var groupIdx = parseInt(group.dataset.optionIndex, 10);
          var buttons = group.querySelectorAll('.js-option-button');
          buttons.forEach(function (btn) {
            var value = btn.dataset.value;
            var hasAvailable = false;
            var hasMatch = false;
            for (var id in variantInfo) {
              if (!variantInfo.hasOwnProperty(id)) continue;
              var v = variantInfo[id];
              if (!v.options) continue;
              var match = true;
              for (var i = 0; i < v.options.length; i++) {
                if (i === groupIdx) {
                  if (v.options[i] !== value) {
                    match = false;
                    break;
                  }
                } else {
                  if (v.options[i] !== currentSelected[i]) {
                    match = false;
                    break;
                  }
                }
              }
              if (match) {
                hasMatch = true;
                if (v.available) {
                  hasAvailable = true;
                  break;
                }
              }
            }
            if (!hasMatch) {
              btn.classList.add('is-out-of-stock');
            } else if (!hasAvailable) {
              btn.classList.add('is-out-of-stock');
            } else {
              btn.classList.remove('is-out-of-stock');
            }
          });
        });
      }

      var optionContainer = container.querySelector('.js-product-option');
      if (optionContainer) {
        optionContainer.addEventListener('click', function (e) {
          var btn = e.target.closest('.js-option-button');
          if (!btn) return;
          var group = btn.closest('.product-option');
          var buttons = group.querySelectorAll('.js-option-button');
          buttons.forEach(function (b) {
            b.classList.remove('active');
          });
          btn.classList.add('active');
          updateStockStates();
          updateInput();
          updateGallery();
          updatePrice();
          updateCurrentValues();
          updateColorSwatches();
          updateQuantity();
          updateTotalPrice();
          updateAddToCartButton();
        });
      }

      updateStockStates();
      updateInput();
      updatePrice();
      updateCurrentValues();
      updateColorSwatches();
      updateQuantity();
      updateAddToCartButton();

      var qtyMinus = container.querySelector('.js-quantity-minus');
      var qtyPlus = container.querySelector('.js-quantity-plus');
      var qtyInput = container.querySelector('.js-quantity-input');

      if (qtyMinus && qtyInput) {
        qtyMinus.addEventListener('click', function () {
          var val = parseInt(qtyInput.value, 10) || 1;
          if (val > 1) {
            qtyInput.value = val - 1;
          }
        });
      }

      if (qtyPlus && qtyInput) {
        qtyPlus.addEventListener('click', function () {
          var val = parseInt(qtyInput.value, 10) || 1;
          var max = parseInt(qtyInput.getAttribute('max'), 10) || 9999;
          if (val < max) {
            qtyInput.value = val + 1;
          }
        });
      }

      if (qtyInput) {
        qtyInput.addEventListener('change', function () {
          var val = parseInt(qtyInput.value, 10) || 1;
          var max = parseInt(qtyInput.getAttribute('max'), 10) || 9999;
          if (val < 1) {
            qtyInput.value = 1;
          } else if (val > max) {
            qtyInput.value = max;
          }
        });
      }

      function formatMoney(cents) {
        var result = '';
        var formatEl = container.querySelector('.total-price-container');
        var format = formatEl ? formatEl.dataset.moneyFormat : '{{amount}}';
        if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
          result = Shopify.formatMoney(cents, format);
        } else {
          var amount = (cents / 100).toFixed(2);
          var parts = amount.split('.');
          if (format.indexOf('{{amount_with_comma_separator}}') !== -1) {
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
            amount = parts[0] + ',' + parts[1];
            result = format.replace('{{amount_with_comma_separator}}', amount);
          } else {
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            amount = parts[0] + '.' + parts[1];
            result = format.replace('{{amount}}', amount);
          }
        }
        return stripHtml(result);
      }

      function updateTotalPrice() {
        var options = getSelectedOptions();
        var variant = findVariantByOptions(options);
        if (!variant) return;
        var mainPrice = variant.data.price || 0;
        var qty = parseInt(container.querySelector('.js-quantity-input').value, 10) || 1;
        var addonTotal = 0;
        var addonOriginalTotal = 0;

        var checkedBoxes = container.querySelectorAll('.js-rec-check:checked');
        checkedBoxes.forEach(function (box) {
          var productItem = box.closest('.js-product-item');
          var priceRaw = 0;
          var originalRaw = 0;
          if (productItem) {
            var select = productItem.querySelector('.js-recommend-variant-select');
            if (select) {
              var selectedOption = select.options[select.selectedIndex];
              if (selectedOption && selectedOption.dataset.priceRaw) {
                priceRaw = parseInt(selectedOption.dataset.priceRaw, 10) || 0;
              }
              if (selectedOption && selectedOption.dataset.originalPriceRaw) {
                originalRaw = parseInt(selectedOption.dataset.originalPriceRaw, 10) || 0;
              }
            } else {
              priceRaw = parseInt(box.dataset.priceRaw, 10) || 0;
              originalRaw = parseInt(box.dataset.originalPriceRaw, 10) || 0;
            }
          } else {
            priceRaw = parseInt(box.dataset.priceRaw, 10) || 0;
            originalRaw = parseInt(box.dataset.originalPriceRaw, 10) || 0;
          }
          addonTotal += priceRaw;
          addonOriginalTotal += originalRaw || priceRaw;
        });

        var total = (mainPrice + addonTotal) * qty;
        var totalEl = container.querySelector('.js-total-price');
        if (totalEl) {
          totalEl.textContent = formatMoney(total);
        }
        var stickyTotal = document.querySelector('.js-sticky-total-price');
        if (stickyTotal) {
          stickyTotal.textContent = totalEl ? totalEl.textContent : formatMoney(total);
        }

        var hasCheckedAddons = container.querySelectorAll('.js-rec-check:checked').length > 0;
        var accRow = container.querySelector('.total-acc-price');
        var accPriceEl = document.getElementById('jsaccprice');
        var accSaveEl = document.getElementById('accsaveprice');

        if (hasCheckedAddons) {
          if (accRow) accRow.style.display = '';
          if (accPriceEl) accPriceEl.textContent = formatMoney(addonTotal * qty);

          var savings = addonOriginalTotal - addonTotal;
          if (accSaveEl && savings > 0) {
            accSaveEl.textContent = '(' + accSaveEl.dataset.label + ' ' + formatMoney(savings * qty) + ')';
            accSaveEl.style.display = '';
          } else if (accSaveEl) {
            accSaveEl.style.display = 'none';
          }
        } else {
          if (accRow) accRow.style.display = 'none';
          if (accPriceEl) accPriceEl.textContent = '';
          if (accSaveEl) accSaveEl.style.display = 'none';
        }

        var klarnaPlacement = container.querySelector('.js-klarna-placement');
        if (klarnaPlacement) {
          klarnaPlacement.setAttribute('data-purchase-amount', Math.round(total));
          function tryRefreshKlarna() {
            if (window.KlarnaOnsiteService && Array.isArray(window.KlarnaOnsiteService)) {
              window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
            }
          }
          tryRefreshKlarna();
          setTimeout(tryRefreshKlarna, 1000);
          setTimeout(tryRefreshKlarna, 2500);
        }
      }

      // 数量变化时更新总价
      if (qtyInput) {
        qtyInput.addEventListener('change', updateTotalPrice);
      }
      if (qtyMinus) {
        qtyMinus.addEventListener('click', function () {
          setTimeout(updateTotalPrice, 0);
        });
      }
      if (qtyPlus) {
        qtyPlus.addEventListener('click', function () {
          setTimeout(updateTotalPrice, 0);
        });
      }

      // 弹窗内 Add to cart 标签：关闭弹窗 + 勾选对应产品
      container.querySelectorAll('.js-drawer-label[data-checkbox]').forEach(function (label) {
        label.addEventListener('click', function () {
          var cb = document.getElementById(this.dataset.checkbox);
          if (cb) {
            cb.checked = true;
            cb.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });

      // 推荐产品勾选变化时更新总价
      var recChecks = container.querySelectorAll('.js-rec-check');
      recChecks.forEach(function (box) {
        box.addEventListener('change', updateTotalPrice);
      });

      // 折扣匹配后，配件联动：勾一个全勾，取消一个全取消；免费则强制勾选
      container.querySelectorAll('.js-rec-check[data-original-price-raw]').forEach(function (box) {
        box.addEventListener('change', function () {
          var config = getDiscountConfig();
          if (!isDiscountActive(config)) return;
          if (config.type === '免费') {
            box.checked = true;
            if (container._updateTotalPrice) container._updateTotalPrice();
            return;
          }
          var checked = box.checked;
          container.querySelectorAll('.js-rec-check[data-original-price-raw]').forEach(function (other) {
            other.checked = checked;
          });
          if (container._updateTotalPrice) container._updateTotalPrice();
        });
      });

      container._updateTotalPrice = updateTotalPrice;
      updateTotalPrice();
      document.querySelectorAll('.dealtag').forEach(function (t) { t.style.display = 'none'; });
      applyDiscountToAllItems();

      function getSelectedItemsData() {
        var items = [];
        var mainVariantId = container.dataset.selectedVariant;
        var mainQty = parseInt(container.querySelector('.js-quantity-input').value, 10) || 1;
        if (!mainVariantId) return null;
        items.push({ id: mainVariantId, qty: mainQty });

        var checkedBoxes = container.querySelectorAll('.js-rec-check:checked');
        checkedBoxes.forEach(function (box) {
          var variantId = box.getAttribute('data-variant-id');
          if (variantId) {
            items.push({ id: variantId, qty: mainQty });
          }
        });
        return items;
      }

      /* 飞书机器人通知 — 提取为公共函数，加购和结账共用 */
      function sendFeishuNotification(label, selectedItems) {
        try {
          var productTitle = container.dataset.productTitle || 'N/A';
          var sku = container.dataset.selectedSku || '';
          var qty = selectedItems[0] ? selectedItems[0].qty : 1;
          var variantId = container.dataset.selectedVariant;
          var vData = variantId && variantInfo ? variantInfo[variantId] : null;
          var price = vData ? vData.price_formatted : 'N/A';
          var options = vData && vData.options ? vData.options.join(' / ') : '';

          var utm = window.iveUtm || {};
          var utmStr = '';
          if (utm.utm_source) utmStr += 'utm_source=' + utm.utm_source;
          if (utm.utm_medium) utmStr += (utmStr ? ', ' : '') + 'utm_medium=' + utm.utm_medium;
          if (utm.utm_campaign) utmStr += (utmStr ? ', ' : '') + 'utm_campaign=' + utm.utm_campaign;

          var addonStr = '';
          var checkedBoxes = container.querySelectorAll('.js-rec-check:checked');
          checkedBoxes.forEach(function (box) {
            var itemEl = box.closest('.js-product-item');
            if (!itemEl) return;
            var titleEl = itemEl.querySelector('.recommend-product-title');
            var addonTitle = titleEl ? titleEl.textContent.trim() : 'N/A';
            var addonPrice = parseInt(box.dataset.priceRaw, 10) || 0;
            addonStr += '\n  + ' + addonTitle + ' (€' + (addonPrice / 100).toFixed(2) + ')';
          });

          var msg = label + '\n' +
            '产品：' + productTitle + '\n' +
            '数量：' + qty + '\n' +
            '价格：' + price + '\n' +
            'SKU：' + sku + '\n' +
            '变体：' + (options || 'N/A') + '\n' +
            (addonStr ? '配件：' + addonStr + '\n' : '') +
            (utmStr ? 'UTM：' + utmStr + '\n' : '') +
            '时间：' + new Date().toLocaleString() + '\n' +
            '链接：' + window.location.href;

          fetch(window.IVE_FEISHU_HOOK, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              msg_type: 'text',
              content: { text: msg }
            })
          }).catch(function () { /* 静默失败 */ });
        } catch (e) { /* 静默失败 */ }
      }

      var addToCartButton = container.querySelector('.js-product-add-cart');
      if (addToCartButton) {
        addToCartButton.addEventListener('click', function (e) {
          e.preventDefault();
          var selectedItems = getSelectedItemsData();
          if (!selectedItems) return;
          var itemsForAjax = selectedItems.map(function (item) {
            return { id: parseInt(item.id, 10), quantity: item.qty };
          });

          addToCartButton.classList.add('is-loading');
          addToCartButton.disabled = true;

          fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: itemsForAjax })
          })
            .then(function (response) {
              if (response.ok) {
                if (window.themeCore && window.themeCore.CartApi) {
                  window.themeCore.CartApi.makeRequest(window.themeCore.CartApi.actions.GET_CART);
                }
                sendFeishuNotification('🛒 用户加购', selectedItems);
              }
            })
            .catch(function (error) {
              console.error('Add to cart error:', error);
            })
            .finally(function () {
              addToCartButton.classList.remove('is-loading');
              addToCartButton.disabled = false;
            });
        });
      }

      var buyNowButton = container.querySelector('.js-shop-check');
      if (buyNowButton) {
        buyNowButton.addEventListener('click', function (e) {
          e.preventDefault();
          var selectedItems = getSelectedItemsData();
          if (!selectedItems) return;
          var pathSegments = selectedItems.map(function (item) {
            return item.id + ':' + item.qty;
          }).join(',');
          sendFeishuNotification('💳 用户直接结账', selectedItems);
          window.location.href = '/cart/' + pathSegments;
        });
      }

      var notifyForm = container.querySelector('.js-notify-me-form');
      if (notifyForm) {
        // capture 阶段拦截，阻止 Shopify 的委派事件触发
        notifyForm.addEventListener('submit', function (e) {
          e.preventDefault();
          e.stopPropagation();

          var bodyEl = container.querySelector('.js-notify-me-body');
          var noteEl = container.querySelector('.js-notify-me-note');
          var sku = container.dataset.selectedSku || '';
          var note = noteEl ? noteEl.value : '';
          var translationsEl = document.querySelector('script[data-ive-translations]');
          var translations = translationsEl ? JSON.parse(translationsEl.textContent) : {};
          var country = translations.country || '';

          var productTitleEl = container.querySelector('.js-notify-me-product-title');
          var productTitle = productTitleEl ? productTitleEl.value : '';

          // 组装 contact[body]
          if (bodyEl) {
            bodyEl.value =
              'Product: ' + productTitle + '\n' +
              'SKU: ' + sku + '\n' +
              'Country Code: ' + country + '\n' +
              'Product URL: ' + window.location.href + '\n' +
              'Note: ' + note + '\n' +
              '---\n' +
              'Please notify me when this product is back in stock.';
          }

          var submitBtn = container.querySelector('.js-notify-me-submit');
          if (submitBtn) {
            submitBtn.disabled = true;
            submitBtn.textContent = translations.sending || 'Sending...';
          }

          // 从页面读取 authenticity_token
          var tokenEl = document.querySelector('[name="authenticity_token"]');
          var token = tokenEl ? tokenEl.value : '';

          var formData = new FormData(notifyForm);
          if (token) formData.append('authenticity_token', token);
          var body = new URLSearchParams(formData).toString();

          fetch('/contact', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              'Accept': 'application/json'
            },
            body: body
          })
          .then(function (res) {
            if (res.ok) {
              var successEl = container.querySelector('.js-notify-me-form-success');
              notifyForm.style.display = 'none';
              if (successEl) successEl.style.display = '';
            } else {
              throw new Error('Submission failed');
            }
          })
          .catch(function () {
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.textContent = translations.notify_me_error || 'Something went wrong. Please try again.';
            }
          });
        }, true); // capture phase: 在 Shopify 委派事件之前拦截
      }
    }

    // === 影子结账栏 ===
    function initStickyCheckout() {
      var wrapper = document.querySelector('.js-checkout-button-wrapper');
      var sticky = document.querySelector('.js-sticky-checkout');
      if (!wrapper || !sticky) return;

      var addBtn = wrapper.querySelector('.js-product-add-cart');
      var buyBtn = wrapper.querySelector('.js-shop-check');
      var notifyBtn = wrapper.querySelector('.js-notify-me-trigger');
      var stickyAdd = sticky.querySelector('.js-sticky-add-cart');
      var stickyBuy = sticky.querySelector('.js-sticky-buy-now');
      var stickyNotify = sticky.querySelector('.js-sticky-notify');
      var stickyAddText = sticky.querySelector('.js-sticky-add-cart-text');
      var addBtnText = wrapper.querySelector('.js-product-add-to-cart-button-text');
      var totalPrice = document.querySelector('.js-total-price');
      var stickyTotalPrice = sticky.querySelector('.js-sticky-total-price');

      // IntersectionObserver：原按钮滚出视口时显示影子栏
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            sticky.classList.remove('is-active');
          } else {
            sticky.classList.add('is-active');
          }
        });
      }, { threshold: 0 });

      observer.observe(wrapper);

      // 同步按钮状态
      function syncButtons() {
        if (addBtn && stickyAdd) {
          stickyAdd.disabled = addBtn.disabled;
          if (addBtn.classList.contains('is-disabled')) {
            stickyAdd.classList.add('is-disabled');
          } else {
            stickyAdd.classList.remove('is-disabled');
          }
          if (addBtn.classList.contains('is-loading')) {
            stickyAdd.classList.add('is-loading');
          } else {
            stickyAdd.classList.remove('is-loading');
          }
        }
        if (addBtnText && stickyAddText) {
          stickyAddText.textContent = addBtnText.textContent;
        }
        if (buyBtn && stickyBuy) {
          stickyBuy.disabled = buyBtn.disabled;
          stickyBuy.style.display = buyBtn.style.display;
        }
        if (notifyBtn && stickyNotify) {
          stickyNotify.style.display = notifyBtn.style.display;
        }
        if (totalPrice && stickyTotalPrice) {
          stickyTotalPrice.textContent = totalPrice.textContent;
        }
      }

      // 影子加购按钮
      if (stickyAdd && addBtn) {
        stickyAdd.addEventListener('click', function () { addBtn.click(); });
      }
      // 影子Buy Now按钮
      if (stickyBuy && buyBtn) {
        stickyBuy.addEventListener('click', function () { buyBtn.click(); });
      }
      // 补货通知按钮 — 飞书推送
      function sendNotifyFeishu() {
        try {
          if (!window.IVE_FEISHU_NOTIFY_HOOK) return;
          var pc = document.querySelector('.ivelok-template');
          var adminId = (pc && pc.dataset.stockAdmin) || '';
          var country = (pc && pc.dataset.userCountry) || (window.location.hostname === 'uk.ivelok.com' ? 'GB' : 'EU');
          var msg = '🔔 你要补货啦\n' +
            '国家：' + country + '\n' +
            '产品：' + ((pc && pc.dataset.productTitle) || 'N/A') + '\n' +
            'SKU：' + ((pc && pc.dataset.selectedSku) || 'N/A') + '\n' +
            '时间：' + new Date().toLocaleString() + '\n' +
            '链接：' + window.location.href;
          if (adminId) {
            msg += '\n<at user_id=\"' + adminId + '\"></at> 请尽快做出行动，确保库存正确哦';
          }
          fetch(window.IVE_FEISHU_NOTIFY_HOOK, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ msg_type: 'text', content: { text: msg } })
          }).catch(function () {});
        } catch (e) {}
      }
      if (stickyNotify) {
        stickyNotify.addEventListener('click', sendNotifyFeishu, true);
      }
      if (notifyBtn) {
        notifyBtn.addEventListener('click', sendNotifyFeishu, true);
      }

      // 初始同步
      syncButtons();

      // 监听原按钮变化
      if (window.MutationObserver) {
        var btnObserver = new MutationObserver(syncButtons);
        if (addBtn) btnObserver.observe(addBtn, { attributes: true, attributeFilter: ['disabled', 'class'] });
        if (buyBtn) btnObserver.observe(buyBtn, { attributes: true, attributeFilter: ['disabled', 'style'] });
        if (notifyBtn) btnObserver.observe(notifyBtn, { attributes: true, attributeFilter: ['style'] });
        if (addBtnText) btnObserver.observe(addBtnText, { characterData: true, subtree: true });
        if (totalPrice) btnObserver.observe(totalPrice, { characterData: true, subtree: true });
      }
    }

    function initAll() {
      try { initGallery(); } catch (e) { console.error('initGallery error:', e); }
      try { initRecommendGalleries(); } catch (e) { console.error('initRecommendGalleries error:', e); }
      try { initVideoGallery(); } catch (e) { console.error('initVideoGallery error:', e); }
      try { initMediaTabs(); } catch (e) { console.error('initMediaTabs error:', e); }
      try { initLightbox(); } catch (e) { console.error('initLightbox error:', e); }
      try { initVariantSelection(); } catch (e) { console.error('initVariantSelection error:', e); }
      try { initStickyCheckout(); } catch (e) { console.error('initStickyCheckout error:', e); }
    }

    document.addEventListener('change', function (event) {
      var variantSelect = event.target.closest('.js-recommend-variant-select');
      if (!variantSelect) return;

      var productItem = variantSelect.closest('.js-product-item');
      var checkbox = productItem.querySelector('.js-rec-check');
      var selectedVariantId = variantSelect.value;
      checkbox.setAttribute('data-variant-id', selectedVariantId);

      var selectedOption = variantSelect.options[variantSelect.selectedIndex];
      var price = selectedOption.dataset.price;
      var compareAtPrice = selectedOption.dataset.compareAtPrice;
      var newImage = selectedOption.dataset.image;
      var newImageAlt = selectedOption.dataset.imageAlt;
      var priceEl = productItem.querySelector('.recommend-product-price');
      var ins = priceEl.querySelector('.js-price__current');
      var del = priceEl.querySelector('.js-price__compare');

      if (newImage) {
        var img = productItem.querySelector('.js-recommend-checkbox label img');
        if (img) {
          img.src = newImage;
          if (newImageAlt) img.alt = newImageAlt;
        }
      }

      var discountConfig = getDiscountConfig();
      var isDiscounted = isDiscountActive(discountConfig);

      if (isDiscounted) {
        applyDiscountToItem(productItem, discountConfig);
      } else {
        ins.textContent = price;
        if (compareAtPrice) {
          if (del) {
            del.textContent = compareAtPrice;
          } else {
            var newDel = document.createElement('del');
            newDel.className = 'js-price__compare';
            newDel.textContent = compareAtPrice;
            priceEl.appendChild(newDel);
          }
        } else {
          if (del) del.remove();
        }
      }

      var tpl = document.querySelector('.ivelok-template');
      if (tpl && tpl._updateTotalPrice) {
        tpl._updateTotalPrice();
      }
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      if (e.target.querySelector('.ivelok-template')) {
        initVariantSelection();
      }
    });
  })();